export default {
    "name": "DashboardConfigurationData",
    "kind": "HoudiniQuery",
    "hash": "7aecb711bf38be75c12cdcb3950b816e1080507d133ec7a5094d19634f60747b",

    "raw": `query DashboardConfigurationData($args: DashboardReportArgs) {
  dashboardReports(args: $args) {
    dashboardReportId: id
    reportName: name
    reportTitle: title
    autoRefreshInterval
    json
    shareType
    shareId
    ownerId
    id
  }
  charts: dashboardCharts {
    chartId: id
    name
    title
    supertype
    showChart: display
    json: jsonDefault
    id
  }
  groups {
    id
    name
  }
  users: userAccounts {
    id
    name
    firstName
    lastName
  }
  stores {
    id
    code
    name
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "dashboardReports": {
                "type": "DashboardReport",
                "keyRaw": "dashboardReports(args: $args)",

                "selection": {
                    "fields": {
                        "dashboardReportId": {
                            "type": "Int",
                            "keyRaw": "dashboardReportId",
                            "visible": true
                        },

                        "reportName": {
                            "type": "String",
                            "keyRaw": "reportName",
                            "visible": true
                        },

                        "reportTitle": {
                            "type": "String",
                            "keyRaw": "reportTitle",
                            "visible": true
                        },

                        "autoRefreshInterval": {
                            "type": "Float",
                            "keyRaw": "autoRefreshInterval",
                            "visible": true
                        },

                        "json": {
                            "type": "String",
                            "keyRaw": "json",
                            "visible": true
                        },

                        "shareType": {
                            "type": "DashboardReportShareType",
                            "keyRaw": "shareType",
                            "nullable": true,
                            "visible": true
                        },

                        "shareId": {
                            "type": "Int",
                            "keyRaw": "shareId",
                            "nullable": true,
                            "visible": true
                        },

                        "ownerId": {
                            "type": "Int",
                            "keyRaw": "ownerId",
                            "nullable": true,
                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "charts": {
                "type": "DashboardChart",
                "keyRaw": "charts",

                "selection": {
                    "fields": {
                        "chartId": {
                            "type": "Int",
                            "keyRaw": "chartId",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "title": {
                            "type": "String",
                            "keyRaw": "title",
                            "visible": true
                        },

                        "supertype": {
                            "type": "DashboardChartSupertype",
                            "keyRaw": "supertype",
                            "visible": true
                        },

                        "showChart": {
                            "type": "Boolean",
                            "keyRaw": "showChart",
                            "visible": true
                        },

                        "json": {
                            "type": "String",
                            "keyRaw": "json",
                            "visible": true
                        },

                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "groups": {
                "type": "Group",
                "keyRaw": "groups",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "users": {
                "type": "UserAccount",
                "keyRaw": "users",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        },

                        "firstName": {
                            "type": "String",
                            "keyRaw": "firstName",
                            "nullable": true,
                            "visible": true
                        },

                        "lastName": {
                            "type": "String",
                            "keyRaw": "lastName",
                            "nullable": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            },

            "stores": {
                "type": "Store",
                "keyRaw": "stores",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "code": {
                            "type": "String",
                            "keyRaw": "code",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "args": "DashboardReportArgs"
        },

        "types": {
            "DashboardReportArgs": {
                "editableByCurrentUser": "Boolean",
                "sharedWithCurrentUser": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=8b0054defa47b8f382e4a8a4a60e32d97fa462e7e1d290378ee214a606a983cf";